import { useEffect, useState } from 'react';

export const useWristSize = (
  currentStrapSize?: string | null,
  unit?: 'mm' | 'inch',
  strapMaterial?: string | null,
) => {
  const isRubber = strapMaterial === 'rubber';
  const sizeMap = {
    mm: {
      default: isRubber ? { min: 170, max: 220 } : { min: 165, max: 185 },
      Large: { min: 185, max: 215 },
      Small: { min: 135, max: 165 },
    },
    inch: {
      default: isRubber ? { min: 6.69, max: 8.66 } : { min: 6.5, max: 7.28 },
      Large: { min: 7.28, max: 8.46 },
      Small: { min: 5.31, max: 6.5 },
    },
  };

  const [wristInterval, setWristInterval] = useState(
    sizeMap[unit ?? 'inch'].default,
  );

  useEffect(() => {
    const newInterval =
      currentStrapSize &&
      (currentStrapSize === 'Large' || currentStrapSize === 'Small')
        ? sizeMap[unit ?? 'inch'][currentStrapSize]
        : sizeMap[unit ?? 'inch'].default;

    if (
      wristInterval.min !== newInterval.min ||
      wristInterval.max !== newInterval.max
    ) {
      setWristInterval(newInterval);
    }
  }, [currentStrapSize, unit, strapMaterial]);

  return wristInterval;
};
